import { Resource, ResourceProps } from 'ia-react-core';
import React, { FC } from 'react';
import { OptionDto } from '../../../../../interfaces/dtos/OptionDto';
import getApiRoot from '../../../../../utils/getApiRoot';
import transformData from './transformData';

export interface ProvincesLoaderProps extends ResourceProps<OptionDto[]> { url: string }

const ProvincesLoader: FC<ProvincesLoaderProps> = ({ url, ...props }) => (
  <Resource
    autoRequest
    name="provincesResource"
    url={`${getApiRoot()}/personal-information/provinces?countryCode=${url}`}
    dataDst="provinces"
    config={{
      transformResponse: ({ data }: { data: OptionDto[] }) => transformData(data),
    }}
    {...props}
  />
);

export default ProvincesLoader;
